import { Component, Input } from '@angular/core';
import { IUnifiedBackgroundCheckDateItem } from '../../../../core/interfaces/unified-background-check.interface';
import { DriverBackgroundCheckStateService } from '../../driver-background-check-state.service';
import { DEACTIVATE_REASON_MAX_LENGTH } from '../../driver-background-check.constants';

@Component({
  selector: 'app-bgc-deactivate-modal',
  templateUrl: './bgc-deactivate-modal.component.html',
  styleUrls: ['./bgc-deactivate-modal.component.scss', '../../driver-background-check.component.scss']
})
export class BgcDeactivateModalComponent {
  @Input() report: IUnifiedBackgroundCheckDateItem;
  @Input() error: string;

  reasonText = '';
  readonly reasonMaxLength = DEACTIVATE_REASON_MAX_LENGTH;

  constructor(public stateService: DriverBackgroundCheckStateService) {}
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/components/bgc-deactivate-modal/bgc-deactivate-modal.component.ts